/**
 * Feature rules registry — pure functions for validating block data.
 * Importable by both cogo-validator and generation pipeline (Cloudflare/Edge).
 */

export type { FeatureRule, RuleViolation, BlockData } from "../types"
import type { FeatureRule, RuleViolation, BlockData } from "../types"
import { interactiveBindingRule } from "./interactive-binding"
import { cartFlowRule } from "./cart-flow"
import { authFlowRule } from "./auth-flow"
import { stateConsistencyRule } from "./state-consistency"

const ALL_RULES: FeatureRule[] = [
  interactiveBindingRule,
  cartFlowRule,
  authFlowRule,
  stateConsistencyRule,
]

/** Run all applicable feature rules on block data */
export function checkAllRules(data: BlockData): RuleViolation[] {
  const violations: RuleViolation[] = []
  for (const rule of ALL_RULES) {
    if (rule.detect(data)) {
      violations.push(...rule.check(data))
    }
  }
  return violations
}

/** Get all registered rules */
export function getAllRules(): FeatureRule[] {
  return [...ALL_RULES]
}

/** Run a specific rule by ID */
export function checkRule(id: string, data: BlockData): RuleViolation[] {
  const rule = ALL_RULES.find((r) => r.id === id)
  if (!rule) return []
  if (!rule.detect(data)) return []
  return rule.check(data)
}
